/* eslint-disable @typescript-eslint/no-explicit-any */

export const canFetchMoreMissions = (result: any) =>
  result?.fetchMissionsBySchoolAndSchoolYear?.pageInfo?.page &&
  result?.fetchMissionsBySchoolAndSchoolYear?.pageInfo?.page <
    (result?.fetchMissionsBySchoolAndSchoolYear?.pageInfo?.pageCount || 0);

export const canFetchMoreCourses = (result: any) =>
  result?.courses?.pageInfo?.page && result?.courses?.pageInfo?.page < (result?.courses?.pageInfo?.pageCount || 0);

export const canFetchMoreProgrammes = (result: any) =>
  (result?.programmes?.meta?.pagination?.page || 1) < (result?.programmes?.meta?.pagination?.pageCount || 1);

export const canFetchMoreResources = (result: any) =>
  (result?.resources?.meta?.pagination?.page || 1) < (result?.resources?.meta?.pagination?.pageCount || 1);

export const buildMissionsFetchMoreVariables = (baseVariables: any, currentResult: any) => ({
  ...baseVariables,
  pagination: {
    start: currentResult?.fetchMissionsBySchoolAndSchoolYear?.nodes?.length || 0,
    limit: 2,
  },
});

export const buildCoursesFetchMoreVariables = (baseVariables: any, currentResult: any) => ({
  ...baseVariables,
  pagination: {
    pageSize: 2,
    page: (currentResult?.courses?.pageInfo?.page || 1) + 1,
  },
});

export const buildProgrammesFetchMoreVariables = (baseVariables: any, currentResult: any) => ({
  ...baseVariables,
  pagination: {
    pageCount: 2,
    page: (currentResult?.programmes?.meta?.pagination?.page || 1) + 1,
  },
});

export const buildResourcesFetchMoreVariables = (baseVariables: any, currentResult: any) => ({
  ...baseVariables,
  page: (currentResult?.resources?.meta?.pagination?.page || 1) + 1,
  limit: 2,
});

export const updateMissionsQuery = (prev: any, { fetchMoreResult }: any) => {
  if (!fetchMoreResult) return prev;

  const prevNodes = prev?.fetchMissionsBySchoolAndSchoolYear?.nodes || [];
  const newNodes = fetchMoreResult.fetchMissionsBySchoolAndSchoolYear?.nodes || [];

  const newMissions = newNodes.filter(
    (newItem: any) => !prevNodes.some((prevItem: any) => prevItem.slug === newItem.slug),
  );

  return {
    ...prev,
    fetchMissionsBySchoolAndSchoolYear: {
      ...prev.fetchMissionsBySchoolAndSchoolYear,
      nodes: [...prevNodes, ...newMissions],
      pageInfo: fetchMoreResult.fetchMissionsBySchoolAndSchoolYear?.pageInfo,
    },
  };
};

export const updateCoursesQuery = (prev: any, { fetchMoreResult }: any) => {
  if (!fetchMoreResult || !fetchMoreResult.courses?.pageInfo) return prev;

  const prevNodes = prev?.courses?.nodes || [];
  const newNodes = fetchMoreResult.courses?.nodes || [];

  const newCourses = newNodes.filter((newItem: any) => !prevNodes.some((prevItem: any) => prevItem.id === newItem.id));

  return {
    ...prev,
    courses: {
      ...prev.courses,
      nodes: [...prevNodes, ...newCourses],
      pageInfo: fetchMoreResult.courses.pageInfo,
    },
  };
};

export const updateProgrammesQuery = (prev: any, { fetchMoreResult }: any) => {
  if (!fetchMoreResult || !fetchMoreResult.programmes?.meta) {
    return prev;
  }

  const prevData = prev?.programmes?.data || [];
  const newData = fetchMoreResult.programmes?.data || [];

  const newProgrammes = newData.filter((newItem: any) => !prevData.some((prevItem: any) => prevItem.id === newItem.id));

  const updated = {
    ...prev,
    programmes: {
      ...prev.programmes,
      data: [...prevData, ...newProgrammes],
      meta: fetchMoreResult.programmes.meta,
    },
  };

  return updated;
};

export const updateResourcesQuery = (prev: any, { fetchMoreResult }: any) => {
  if (!fetchMoreResult || !fetchMoreResult.resources?.meta) {
    return prev;
  }

  const prevData = prev?.resources?.data || [];
  const newData = fetchMoreResult.resources?.data || [];

  const newResources = newData.filter((newItem: any) => !prevData.some((prevItem: any) => prevItem.id === newItem.id));

  const updated = {
    ...prev,
    resources: {
      ...prev.resources,
      data: [...prevData, ...newResources],
      meta: fetchMoreResult.resources.meta,
    },
  };

  return updated;
};
